import { Routes, Route, Navigate } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const AdminSignUp = lazy(() => import('./pages/AdminSignUp'))

function App() {
  return (
    <>
      <ToastContainer autoClose={5000} limit={5} position='top-right' closeOnClick />
      <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Loading...</div>}>
        <Routes>
          <Route>
            <Route path='*' element={<Navigate replace to='/' />} />
            <Route path='/' element={<AdminSignUp />} />
          </Route>
        </Routes>
      </Suspense>
    </>
  )
}

export default App